import React from 'react';

const InputCelularAlteracao = ({
  id,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  legenda,
  ...rest
}) => {
  const handlePaste = (event) => {
    let celularCopiado = event.clipboardData.getData('Text');

    if (celularCopiado.length <= 10) {
      celularCopiado = celularCopiado.replace(/\D/g, '');

      event.target.value = celularCopiado.replace(/^(\d{5})(\d{4})/gi, '$1-$2');
    }
  };

  const handleInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9() -]/g, '');
  };

  const handleKeyDown = (e) => {
    let invalidChars = ['(', ')', ' ', '-'];
    const key = e.key;

    if (invalidChars.includes(key)) {
      e.preventDefault();
    }

    if (key !== 'Backspace' && key !== 'Delete') {
      var i = e.target.value.length;

      if (i === 5) e.target.value = e.target.value + '-';
    }
  };

  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo-txt campo-tel ${msgErro ? 'erro' : ''}`}>
      <label className={`subtitulo-p`} htmlFor={id}>
        {label}
      </label>

      <div className="input-container input-com-ic">
        <i className="ic-celular input-ic"></i>

        <input
          type={'text'}
          id={id}
          name={name}
          ref={inputRef}
          className={className}
          placeholder="99999-9999"
          maxLength="10"
          onInput={(e) => handleInput(e)}
          onKeyDown={(e) => handleKeyDown(e)}
          onPaste={(e) => handlePaste(e)}
          {...rest}
        />
      </div>
      <div className="mensagem legenda">
        {legenda} {msgErro}
      </div>
    </div>
  );
};

export default InputCelularAlteracao;
